import type {
  CreateContractImportJobsPayload,
  CreateContractImportJobsResponse,
} from './types';

import { ENDPOINT } from '~/constants/endpoints';

import { type KyRequestOptions } from '@vestigas/data';

import { vestigasApi } from '~/services/kyClient';

import {
  zodCreateContractImportJobsPayloadSchema,
  zodCreateContractImportJobsResponseSchema,
} from './validations';

/**
 * Bulk-creates contract import jobs from FileHub file IDs. Each entry in
 * `jobs` starts one parsing job for that file (max 10 files per request).
 *
 * @param payload - The files to create import jobs from.
 * @param options - Optional request options (e.g., abort signal).
 * @returns The created import job summaries.
 * @throws VestigasHTTPError if the API request fails or validation fails.
 * @see https://app.dev.vestigas.com/redoc#tag/Contract-Import-Jobs/operation/create_import_jobs_contracts_import_jobs_post
 */
export const createContractImportJobs = async (
  payload: CreateContractImportJobsPayload,
  options?: KyRequestOptions,
) =>
  vestigasApi
    .post(ENDPOINT.CONTRACT_IMPORT_JOB.CREATE(), {
      ...options,
      json: payload,
      validate: {
        body: zodCreateContractImportJobsPayloadSchema,
        response: zodCreateContractImportJobsResponseSchema,
      },
    })
    .json<CreateContractImportJobsResponse>();
